// YourSpaceContent.jsx
import React from "react";
import styles from "./YourSpaceContent.module.css";
import backIcon from "../icons/back_icn.png";

function YourSpaceContent({ onBack, onNavigateToStep }) {
  return (
    <div className={styles.yourSpaceContentContainer}>
      <img
        src={backIcon}
        alt="Back"
        className={`${styles.backIcon} ${styles.visible}`}
        onClick={onBack}
      />
      <h1 className={styles.pageTitle}>Твій Простір</h1>
      <div className={`${styles.content} ${styles.visible}`}>
        <img src="/logoCult.svg" className={styles.appLogo} alt="logo" />
        <div className={styles.buttonContainer}>
          <button
            className={styles.button}
            onClick={() => onNavigateToStep(3)}
          >
            <div className={styles.buttonContent}>
              <span className={styles.buttonText}>МОЇ КВИТКИ</span>
            </div>
          </button>

          <button
            className={styles.button}
            onClick={() => onNavigateToStep(4)}
          >
            <div className={styles.buttonContent}>
              <span className={styles.buttonText}>УЛЮБЛЕНІ ПОДІЇ</span>
            </div>
          </button>

          <button
            className={styles.button}
            onClick={() => onNavigateToStep(5)}
          >
            <div className={styles.buttonContent}>
              <span className={styles.buttonText}>ПОВІДОМЛЕННЯ</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default YourSpaceContent;

